<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle">
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12" class="pa-0">
                <v-row no-gutters>
                  <v-col class="pb-1">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="useBtnList"
                      :class="[setBtnColor]"
                      @btnSave="btnSave()" @btnPrint="btnPrint()" @btnDelete="btnDelete()"
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="'Request No :'" />
                          <v-col cols="2">
                            <v-select
                              v-model="resNo"
                              :items="resNoList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="3" class="top">
                    <v-row no-gutters>
                      <v-col cols="5" align="right" class="pt-2 pb-2"><span class="pa-2 search">Carry Out Date: </span></v-col>
                      <v-col cols="5" class="pt-1">
                        <DxDateBox
                          :value="plnCarryOutDte"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {plnCarryOutDte = e.value}"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3" class="top">
                    <v-row no-gutters>
                      <v-col cols="4" align="right" class="pt-2 pb-2"><span class="pa-2 search">Car No : </span></v-col>
                      <v-col cols="6" class="pt-1">
                        <v-autocomplete
                          v-model="carNo"
                          :items="carNoList"
                          return-object
                          item-value="code"
                          item-text="codeName"
                          single-line
                          outlined
                          dense
                          height="32"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6" class="top">
                    <v-row no-gutters>
                      <v-col cols="4" align="right" class="pt-2 pb-2"><span class="pa-2 search">Driver Name : </span></v-col>
                      <v-col cols="5" class="pt-1">
                        <v-select
                          v-model="perNo"
                          :items="perNoList"
                          return-object
                          item-value="code"
                          item-text="codeName"
                          single-line
                          outlined
                          dense
                          height="32"/>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col class="pt-1">
                    <DxDataGrid
                      class="doubleListBox03"
                      id="epms90a1"
                      :ref="epms90a1Ref"
                      :data-source="epms90a1List" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="true"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                    >
                      <DxPaging :enabled="false" />
                      <DxPager :visible="false" />
                      <DxColumn data-field="resSeq" caption="Seq." width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="shipNo" caption="Ship No" width="10%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="porNoSeq" caption="POR No" width="10%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="partNo" caption="Part No" width="10%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="partSpec" caption="Material Specification" width="45%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="resQty" caption="Qty" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="matlUnit" caption="Unit" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="issueShip" alignment="center" width="5%" :allow-editing="false" header-cell-template="Issue" />
                      <template #Issue>
                        <div>Issue<br>Ship No</div>
                      </template>
                      <DxColumn data-field="block" caption="Block" width="5%" alignment="center" :allow-editing="false" />
                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-2">
                <v-row no-gutters>
                  <v-col class="">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="useBtnList2"
                      :customBtnList="customBtnList"
                      @btnRetrieve="getMain2()" @btnSaveAsExcel="btnSaveAsExcel"
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="' Ship No :'" />
                          <v-col cols="2">
                            <v-select
                              v-model="shipNo"
                              :items="shipNoList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="shipNoChange()"
                            />
                          </v-col>
                          <i-label :label="' Raw PORs :'" class="pl-2"/>
                          <v-col cols="2">
                            <v-autocomplete
                              v-model="porNo"
                              :items="porNoList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              outlined
                              dense
                              height="32"
                              @change="getMain2()"
                              />
                          </v-col>
                          <v-col class="pa-1 pl-4">
                            <span class="pa-1 subText" style="background-color: #C0E0FF;">Issued</span>
                            <span class="pa-1 subText" style="background-color: #FFAACC;">Requested</span>
                            <span class="pa-1 subText" style="background-color: #FF4040;">No have Stock</span>
                            <span class="pa-1 subText" style="background-color: #FFFFFF;">Not yet Request</span>
                          </v-col>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col class="pt-1">
                    <DxDataGrid
                      class= "listBox05"
                      id="epms90a2"
                      :ref="epms90a2Ref"
                      :data-source="epms90a2List" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                      :selection="{ mode: 'none' }"
                      @cellPrepared="cellPrepared"
                    >
                      <DxPaging :enabled="true" :page-size="16"/>
                      <DxPager :visible="true" />
                     
                      <DxColumn data-field="selChek" data-type="boolean" width="2%" header-cell-template="selHeader" cell-template="selChkRow" :allow-editing="false" />
                      <template #selHeader = "{ data: cellInfo }" >                                                   
                            <DxCheckBox :value="false" :onValueChanged="value => onValueChanged(value, cellInfo)"  />                        
                      </template>
                      <template #selChkRow  = "{ data: cellInfo }">
                        <DxCheckBox :value="cellInfo.value === 'Y' ? true : false"
                          :onValueChanged="value => onValueChanged2(value, cellInfo)"
                          :disabled="cellInfo.data.seq == '1'&&cellInfo.data.issYn == 'N'&&cellInfo.data.resYn == 'N'&&cellInfo.data.whYn == 'Y' ? false : true" 
                        />
                      </template>                      
                      <DxColumn caption="Original Information" alignment="center" :allow-editing="false" >
                        <DxColumn caption="Ship No" alignment="center" :allow-editing="false" >
                          <DxColumn data-field="shipNo" caption="Code" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn caption="Por No" alignment="center" :allow-editing="false" >
                          <DxColumn data-field="porNoSeq" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn caption="Quantity" alignment="center" :allow-editing="false" >
                          <DxColumn data-field="partQty" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn caption="PO Date" alignment="center" :allow-editing="false" >
                          <DxColumn data-field="poDte" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn alignment="center" :allow-editing="false" header-cell-template="estKas">
                          <DxColumn data-field="makerDlyDt" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn caption="KAS Date" alignment="center" :allow-editing="false" >
                          <DxColumn data-field="kasWhDte" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn alignment="center" :allow-editing="false" header-cell-template="shipping" >
                          <DxColumn data-field="shippingDte" caption="Supplier" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn caption="WH Date" alignment="center" :allow-editing="false" >
                          <DxColumn data-field="whDte" caption="Supplier" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn caption="Issue Date	" alignment="center" :allow-editing="false" >
                          <DxColumn data-field="issueDte" caption="Supplier" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                      </DxColumn>
                      <template #estKas>
                        <div>EstKas Date</div>
                      </template>
                      <template #shipping>
                        <div>Shipping Date</div>
                      </template>

                      <DxColumn caption="Fabrication Information" alignment="center" :allow-editing="false" >
                        <DxColumn caption="Ship No" alignment="center" :allow-editing="false" >
                          <DxColumn data-field="shipNoFab" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn caption="POR No" alignment="center" :allow-editing="false" >
                          <DxColumn data-field="porNoFabLine" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn caption="Part No" alignment="center" :allow-editing="false" >
                          <DxColumn data-field="partNo" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn alignment="center" :allow-editing="false" header-cell-template="useLength" >
                          <DxColumn data-field="uses" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn alignment="center" :allow-editing="false" header-cell-template="cutMargin" >
                          <DxColumn data-field="cuttingMargin" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>
                        <DxColumn alignment="center" :allow-editing="false" header-cell-template="material" >
                          <DxColumn data-field="mnd" caption="Material Spec" width="7%" alignment="center" :allow-editing="false" />
                        </DxColumn>

                      </DxColumn>
                      <template #useLength>
                        <div>Use Length</div>
                      </template>
                      <template #cutMargin>
                        <div>Cut Margin</div>
                      </template>
                      <template #material>
                        <div>MATL Need Dte</div>
                      </template>

                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getCarList , getDriverList } from '@/api/view/hip/common/common.js'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { getResNoList , epms90a1Head , epms90a1Detail , getShipNoList , getPorNoListF ,
    epms90a0List , epms90a2Save , epms90a2Delete , epms90a0xls } from '@/api/view/hip/90/epms90a0'
import { reportView } from '@/api/view/hip/common/common'
import notify from 'devextreme/ui/notify'
import dayjs from 'dayjs';

export default {
  name: 'epms90a0',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
  },
  data() {
    return {
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      menuTitle: this.$route.meta.title,
      epms90a1Ref: 'epms90a1Ref',
      epms90a2Ref: 'epms90a2Ref',

      useBtnList: ['btnSave','btnPrint','btnDelete'],
      useBtnList2: ['btnRetrieve' , 'btnSaveAsExcel'],
      customBtnList: [
        { id: 'btnSaveAsExcel', text: 'Save as Excel', icon: 'excel' }
      ],
      setBtnColor: 'setBtnColor',

      resNo: '',
      resNoList: [],
      carNo: '',
      carNoList: [],
      perNo: '',
      perNoList: [],
      shipNo: '',
      shipNoList: [],
      porNo: '',
      porNoList: [],

      plnCarryOutDte: '',


      epms90a1List: [],
      epms90a2List: [],
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms90a1Ref)
    },
    gridInstance2() {
      return this.GetDataGrid(this.epms90a2Ref)
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.gridInstance.option('defaultPaging', false)
      this.gridInstance2.option('defaultPaging', false)
      this.getList()
    },
    async getList(){
      let param = {
        makerCd: this.makerCd
      }
       this.resNoList = []
      await getResNoList(param).then(res => {
        this.resNoList.push({ code: '', codeName: 'New' })
        
        res.list.forEach(e => {          
          // e.code = ele.resNo
          // e.codeName = ele.resNo
          // this.resNoList.push(e)
          this.resNoList.push({ code: e.resNo, codeName: e.resNo })
        });
        this.resNo = this.resNoList[0]
			})

      await getCarList(param).then(res => {
        this.carNoList.push({code: '' , codeName: ''})
        res.list.forEach(e => {
          e.code = e.carNo
          e.codeName = e.carLicense
          this.carNoList.push(e)
        });
        this.carNo = this.carNoList[0]
			})

      await getDriverList(param).then(res => {
        this.perNoList.push({code: '' , codeName: ''})
        res.list.forEach(e => {
          e.code = e.perNo
          e.codeName = !e.perEnm ? '' : e.perEnm
          this.perNoList.push(e)
        });
        this.perNo = this.perNoList[0]
			})

      await getShipNoList(param).then(res => {
        this.shipNoList.push({code: '' , codeName: 'Select'})
        res.list.forEach(e => {
          e.code = e.shipNo
          e.codeName = !e.shipNo ? '' : e.shipNo
          this.shipNoList.push(e)
        });
        this.shipNo = this.shipNoList[0]
			})
      //this.getMain2()

    },    
    async getPorList() {
            let params = {
                 makerCd: this.makerCd,
                 shipNo: this.shipNo.code,
                 porNo: ''
            }

           // console.log(params)
          this.porNoList = []
          await getPorNoListF(params).then(res => {            
            this.porNoList.push({ code: '', codeName: '' })
            res.list.forEach(e => {
              e.code = e.porNo
              e.codeName = e.porNo
              this.porNoList.push(e)
            });
            this.porNo = this.porNoList[0]
          })
        },
     shipNoChange(e) {
            this.porNo = ''
            this.getPorList()                       
            //this.getMain2()
        },
    btnRetrieve() {
      
     // this.carNo = ''
      this.epms90a1List = []
      this.getMain()
    },
    async getMain(){
      try {
        this.openLoading('searching')
        let param = {
          resNo: this.resNo.code
        }
        console.log('get Main : ', param)
        await epms90a1Head(param).then(res => {
          if(res.list.length > 0){
            this.plnCarryOutDte = res.list[0].plnCarryOutDte
            this.carNoList.forEach(e => {
              if(res.list[0].carNo == e.code){
                this.carNo = {code: res.list[0].carNo , codeName: e.codeName}
              }
            });
          }
        })
        await epms90a1Detail(param).then(res => {
          let cnt = 0
          res.list.forEach(e => {
            e.id = cnt++
            e.porNoSeq = e.porNo + '-' + e.porSeq
          });
          this.epms90a1List = res.list
        })
      } finally {
        this.endLoading()
      }
    },
    async getMain2(){
      try {
        this.openLoading('searching')
        this.epms90a2List = []
        let param = {
          makerCd: this.makerCd,
          shipNo: this.shipNo.code,
          porNo: !this.porNo.code ? '' : this.porNo.code
        }
       
        //console.log(param)
        await epms90a0List(param).then(res => {
          let cnt = 0  , count = 0
          res.list.forEach(e => {
            this.epms90a2List.push(
              {
                id: cnt, 
                shipNo: e.seq == '1'  ? e.shipNo : '', 
                porNoSeq: e.seq == '1'  ? e.porNo + '-' + e.porSeq : '', 
                partQty: e.seq == '1'  ? e.partQty : '', 
                poDte: e.seq == '1'  ? e.poDte : '', 
                makerDlyDt: e.seq == '1'  ? e.makerDlyDt : '', 
                kasWhDte: e.seq == '1'  ? e.kasWhDte : '',
                shippingDte: e.seq == '1'  ? e.shippingDte : '', 
                whDte: e.seq == '1'  ? e.whDte : '', 
                issueDte: e.seq == '1'  ? e.issueDte : '', 
                shipNoFab: e.shipNoFab, porNoFabLine: e.porNoFab + '-' + e.lineNoFab,
                partNo: e.partNo, uses: e.uses, cuttingMargin: e.cuttingMargin, mnd: e.mnd,
                issYn: e.issYn, resYn: e.resYn, whYn: e.whYn, seq: e.seq , selChek: 'N' , count: count++,
                porSeq: e.porSeq , porNo: e.porNo
              },
              {
                id: cnt++, shipNo: e.seq == '1'  ? e.matlCd : '', porNoSeq: e.seq == '1'  ? e.matlSpec : '' , shippingDte: e.makerNm, shipNoFab: e.partSpec,
                issYn: e.issYn, resYn: e.resYn, whYn: e.whYn, seq: e.seq, selChek: 'N', count: count++ ,porSeq: e.porSeq, porNo: e.porNo
              }
            )
          })
        })
      } finally {
        //console.log(this.epms90a2List)
        this.endLoading()
      }
    },
    async btnSave(){
      if(!this.plnCarryOutDte){
        this.vToastify(this.$t("Select Carry Out Date."), 'warn')
        return
      }
      if(!this.carNo.code){
        this.vToastify(this.$t("Input Car No."), 'warn')
        return
      }
      let cnt = 0
      let rowData = []
      this.epms90a2List.forEach(e => {
        if(e.selChek == 'Y'){
          cnt++
          e.resNo = this.resNo.code
          e.makerCd = this.makerCd
          e.plnCarryOutDte = dayjs(this.plnCarryOutDte).format('YYYY-MM-DD')
          e.carNo = this.carNo.code
          e.perNo = !e.perNo ? '' : e.perNo
          rowData.push(e)
        }
      });
      if(cnt === 0){
        this.vToastify(this.$t("Select data."), 'warn')
        return
      }
      
      this.vToastifyPrompt(
        this.$t('Do you want to save the data?'),
        'info',
          current => {
            this.openLoading('searching')
            epms90a2Save(rowData)
              .then(res => {
                const result = res.body
                if(result == 'Y'){
                  notify(this.$t('Saving is completed.'), 'success', 3000)
                } else {
                  this.vToastify(this.$t(result), 'warn')
                }
              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.plnCarryOutDte = ''
                this.carNo = ''
                this.getList().then(() =>
                { 
                  this.resNo = this.resNoList.slice(-1)[0]
                 // this.res_no = this.resNoList[this.resNoList.length - 1]

                  console.log('res No', this.resNo)

                  this.getMain()

                }).finally(() => {
                  this.porNo = ''
                  this.getPorList()
                  this.getMain2()
                })                                
                this.endLoading()
              })
          },
        null,
        true
      )
    },
    btnPrint(){
      if(!this.resNo.code){
        this.vToastify(this.$t("Select Request No."), 'warn')
        return
      }
      const param = {
        fileName: 'epms90a0.jrxml',
        as_res_no: this.resNo.code
      }
      console.log(param)
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    async btnDelete(){
      await this.gridInstance.saveEditData()
      var selectedMainRows = await this.gridInstance.getSelectedRowsData()

      if(!selectedMainRows.length){
        this.vToastify(this.$t("Data is not selected for delete."), 'warn')
        return
      }

      for(var row of selectedMainRows){
        row.div = 'T30E_1119'
        row.userId = this.userId
      }

      this.vToastifyPrompt(
        this.$t('Do you want to delete?'),
        'info',
          current => {
            this.openLoading('searching')
            epms90a2Delete(selectedMainRows)
              .then(res => {
                const result = res.body
                if(result == 'Y'){
                  notify(this.$t('Delete is complete.'), 'success', 3000)
                } else {
                  this.vToastify(this.$t(result), 'warn')
                }
              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.plnCarryOutDte = ''
                this.carNo = ''
                this.getList().then(() => {
                  this.resNo = this.resNoList[0]                

                  this.getMain()

              }).finally(() => {
                this.porNo = ''
                this.getPorList()
                this.getMain2()
              })
                this.endLoading()
              })
          },
        null,
        true
      )

    },
    btnSaveAsExcel(){
      const param = {
        makerCd: this.makerCd,
        shipNo: this.shipNo.code,
        porNo: !this.porNo.code ? '' : this.porNo.code
      }
      epms90a0xls(param)
    },
    async onValueChanged(value, cellInfo){
      for(let i = 0; i < this.epms90a2List.length; i++) {
        let gbn = this.epms90a2List[i]
        if(gbn.seq == '1'&& gbn.issYn == 'N' && gbn.resYn == 'N' && gbn.whYn == 'Y'){
          if(i % 2 === 0){
            if(value.value === true) {
              this.epms90a2List[i].selChek = 'Y'
            } else {
              this.epms90a2List[i].selChek = 'N'
            }
          }
        }
      }
    },
    onValueChanged2(value, cellInfo){
      if(cellInfo.data.selChek == 'N') {
        this.epms90a2List[cellInfo.data.count].selChek = 'Y'
      } else {
        this.epms90a2List[cellInfo.data.count].selChek = 'N'
      }
    },
    cellPrepared(e){
      if (e.rowType === 'header') {
        //e.cellElement.style.border = '1px solid #404040'
        if(e.columnIndex == '1' && e.column.caption === 'Material Spec'){
          e.cellElement.setAttribute('colspan', 5)
        } else if(e.columnIndex == '9' && e.column.caption === 'Material Spec'){
          e.cellElement.setAttribute('colspan', 6)
        } else if((e.columnIndex != '1' && e.columnIndex != '9') && e.column.caption === 'Material Spec'){
          e.cellElement.style.display = 'none'
        } else if(e.columnIndex == '6' && e.column.caption === 'Supplier'){
          e.cellElement.setAttribute('colspan', 3)
        } else if(e.columnIndex != '6' && e.column.caption === 'Supplier'){
          e.cellElement.style.display = 'none'
        }
      } else {
        e.cellElement.style.border = '1px solid #808080'

        if (e.rowIndex % 2 !== 0) {

           if(e.columnIndex == '2' && e.column.caption === 'Material Spec'){
            e.cellElement.setAttribute('colspan', 5)
          }else if(e.columnIndex == '7' && e.column.caption === 'Supplier'){
            e.cellElement.setAttribute('colspan', 3)
          }else if(e.columnIndex == '10' && e.column.caption === 'Material Spec'){
            e.cellElement.setAttribute('colspan', 6)
          }else if((e.columnIndex != '1' && e.columnIndex != '10') && e.column.caption === 'Material Spec'){
            e.cellElement.style.display = 'none'
          }else if(e.columnIndex != '7' && e.column.caption === 'Supplier'){
            e.cellElement.style.display = 'none'
          }
          
        }
       
        if(e.columnIndex == 0 && e.rowIndex % 2 === 0){
          e.cellElement.setAttribute('rowspan', 2)
        }else if(e.columnIndex == 0 && e.rowIndex % 2 != 0){
          e.cellElement.style.display = 'none'
        }
        if (e.data.seq == '1' && e.data.issYn == 'N' && e.data.resYn == 'N' && e.data.whYn == 'Y') {
        

        }else {
          if(e.data.issYn == 'Y'){
            e.cellElement.style.backgroundColor = '#C0E0FF'
          }else if(e.data.resYn == 'Y'){
            e.cellElement.style.backgroundColor = '#FFAACC'
          }else if(e.data.whYn == 'N'){
            e.cellElement.style.backgroundColor = '#FF4040'
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search{
  font-weight: bold;
  color: black;
}
.top{
  background-color: #C0E0FF;
  border-left: 1px solid #B4BAC6;
}
.subText {
  border: 1px solid #B4BAC6;
  color: black;
}
$redBtn: #FF0000;
.setBtnColor::v-deep {
  [role=btnDelete]{
    .v-btn__content {
      div {
        color: #{$redBtn} !important;
      }

      i {
        color: #{$redBtn} !important;
      }
    }
  }
}
</style>
